import clsx from 'clsx';
import React, { useMemo } from 'react';

interface StreamPlayerProps {
  videoId: string;
  isMinimized: boolean;
}

const StreamPlayer = ({ videoId, isMinimized }: StreamPlayerProps) => {
  const iframeSrc = useMemo(() => {
    if (!videoId) return '';
    return `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0&mute=1&playsinline=1&cc_load_policy=1`;
  }, [videoId]);

  return (
    <div
      className={clsx(
        'relative w-full max-w-full flex-shrink-0',
        isMinimized ? 'w-1px h-1px sr-only absolute right-0' : 'aspect-[16/9]'
      )}
    >
      <iframe
        src={iframeSrc}
        allow="autoplay; encrypted-media; fullscreen"
        allowFullScreen
        title="Most Recent TITV Stream"
        className="absolute inset-0 h-full w-full border-0"
        loading="lazy"
      />
    </div>
  );
};

export default StreamPlayer;
